module.exports = __webpack_public_path__ + "73a982d7bf7608e69f3a0f669d0b6524.svg";